"use strict";

exports.__esModule = true;
var _DeviceCycleChart = require("./DeviceCycleChart");
Object.keys(_DeviceCycleChart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceCycleChart[key]) return;
  exports[key] = _DeviceCycleChart[key];
});